type ImageOriginal = {
  width: number;
  height: number;
};

export const ratioCalc = ({ width, height }: ImageOriginal) => {
  if (height > width) return width / height;
  return height / width;
};
